import React from 'react'
import Header from './components/Header'

function About() {
    return (
        <div className="container">
            <Header />
            about
        </div>
    )
}

export default About
